export function getView(filters) {
  return (
    filters.automation_type ||
    filters.type ||
    filters.status ||
    filters.search_term ||
    filters.value_to.length ||
    filters.appointment_type_ids.length
  )
}
